import { createBackofficeServerClient } from '@packages/gql/src/createServerClient';
import { cached } from '@packages/shared/src/utils/cached/cached';
import { CONTENT_CACHE_TTL_SECONDS } from '@packages/shared/src/utils/contentCacheTtl/contentCacheTtl';
import { logger } from '@packages/shared/src/utils/logger/logger';
import {
  type AppConfigData,
  EMPTY_APP_CONFIG,
  fetchAppConfig,
  isCcConsumerShopConfigEnabled,
} from './fetchAppConfig';

const loadAppConfig = async (locale: string): Promise<AppConfigData> => {
  try {
    return await cached(
      `app-config-${locale}`,
      () => fetchAppConfig(createBackofficeServerClient(), locale),
      CONTENT_CACHE_TTL_SECONDS.config * 1000,
    )();
  } catch (error) {
    // `cached` stores nothing when the read throws, so the next request asks again.
    logger.warn({ err: error, locale }, 'App config unavailable, using the static config');
    return EMPTY_APP_CONFIG;
  }
};

/**
 * Pages router counterpart of `getAppConfigData`: plain server client behind the
 * process-wide memory cache. Same TTL, no tag-based revalidation. Never rejects.
 */
export const getPagesRouterAppConfigData = (
  locale: string,
  cookieValue: string | undefined,
): Promise<AppConfigData | null> =>
  isCcConsumerShopConfigEnabled(cookieValue) ? loadAppConfig(locale) : Promise.resolve(null);
